(function () {
  var STORAGE_KEY = 'nfp_recently_viewed_products';
  var MAX_STORED = 12;

  function getStoredHandles() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var handles = raw ? JSON.parse(raw) : [];

      if (!Array.isArray(handles)) return [];

      return handles.filter(function (handle) {
        return typeof handle === 'string' && handle.length > 0;
      });
    } catch (error) {
      return [];
    }
  }

  function saveCurrentHandle(handle) {
    if (!handle) return;

    var handles = getStoredHandles().filter(function (storedHandle) {
      return storedHandle !== handle;
    });

    handles.unshift(handle);
    handles = handles.slice(0, MAX_STORED);

    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
    } catch (error) {
      return;
    }
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }

    return '$' + (cents / 100).toFixed(2);
  }

  function escapeHtml(value) {
    if (!value) return '';

    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function productCardMarkup(product) {
    var image = product.featured_image || '';
    var title = escapeHtml(product.title);
    var url = product.url || ('/products/' + product.handle);
    var price = formatMoney(product.price);
    var compareAt = product.compare_at_price;
    var isOnSale = compareAt && compareAt > product.price;

    return [
      '<article class="nfp-related-card">',
        '<a class="nfp-related-card__link" href="' + url + '">',
          '<div class="nfp-related-card__media">',
            image
              ? '<img src="' + image + '" alt="' + title + '" loading="lazy">'
              : '<div class="nfp-related-card__placeholder">Product image</div>',
            isOnSale ? '<span class="nfp-related-card__badge">Sale</span>' : '',
          '</div>',
          '<div class="nfp-related-card__content">',
            '<h3 class="nfp-related-card__title">' + title + '</h3>',
            '<div class="nfp-related-card__price">',
              isOnSale
                ? '<span class="nfp-related-card__price-sale">' + price + '</span><span class="nfp-related-card__price-compare">' + formatMoney(compareAt) + '</span>'
                : '<span>' + price + '</span>',
            '</div>',
            '<span class="nfp-related-card__cta">View product →</span>',
          '</div>',
        '</a>',
      '</article>'
    ].join('');
  }

  function fetchProduct(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function (response) {
        if (!response.ok) throw new Error('Product not found');
        return response.json();
      });
  }

  function initRecentlyViewed(section) {
    var currentHandle = section.getAttribute('data-current-handle');
    var limit = parseInt(section.getAttribute('data-limit'), 10) || 4;
    var designMode = section.getAttribute('data-design-mode') === 'true';
    var grid = section.querySelector('[data-nfp-recently-viewed-grid]');
    var empty = section.querySelector('[data-nfp-recently-viewed-empty]');

    if (!grid) return;

    var handles = getStoredHandles().filter(function (handle) {
      return handle !== currentHandle;
    }).slice(0, limit);

    saveCurrentHandle(currentHandle);

    if (!handles.length) {
      if (designMode && empty) {
        empty.hidden = false;
      } else {
        section.hidden = true;
      }

      return;
    }

    Promise.allSettled(handles.map(fetchProduct)).then(function (results) {
      var products = results
        .filter(function (result) {
          return result.status === 'fulfilled';
        })
        .map(function (result) {
          return result.value;
        });

      if (!products.length) {
        if (designMode && empty) {
          empty.hidden = false;
        } else {
          section.hidden = true;
        }

        return;
      }

      grid.innerHTML = products.map(productCardMarkup).join('');
      section.hidden = false;
    });
  }

  function initAll() {
    document.querySelectorAll('[data-nfp-recently-viewed]').forEach(initRecentlyViewed);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();